import { GroupList } from './groups/GroupList';
import { GroupCreate } from './groups/GroupCreate';
import { GroupEdit } from './groups/GroupEdit';
import { Groups as GroupsIcon } from '@mui/icons-material';

export const NotificationGroups = {
    list: GroupList,
    create: GroupCreate,
    edit: GroupEdit,
    icon: GroupsIcon,
};